import * as constants from './constants';

export const initialState = {
  loading: false,
  list: {},
  listRequest: {}, // запрос для выборки заявок
  item: {},
  fields: [],
  error: null,

  photoListUser: [], // список пользовательских фото/видео по 1 заявке
  instructionList: [], // список инструкций по 1 заявке
  photoListClient: [], // список клиентских фото/видео по 1 заявке

  loadingPhotoListUser: false, // признак, что идёт загрузка списка photoListUser
  loadingInstructionList: false, // признак, что идёт загрузка списка instructionList
  loadingPhotoListClient: false, // признак, что идёт загрузка списка photoListClient

  photoListUserOrderID: undefined, // id заявки, данные по которой находятся в photoListUser
  instructionListOrderID: undefined, // id заявки, данные по которой находятся в instructionList
  photoListClientOrderID: undefined, // id заявки, данные по которой находятся в photoListClient

  photo: {}, // 1 фото, и сюда же пишем данные и по видео, т.к. формат одинаковый
  comments: [],
  commentsOrderId: null, // orderId по  комментариям, которые должны быть в comments
  temporaryFiles: [], // список временных файлов с архивом
  loadingTemporaryFiles: false, // признак, что идёт загрузка временных файлов
  temporaryFilesOrderId: '', // OrderId по файлам, которые загружены или грузятся в temporaryFiles
  temporaryFilesSourceRefValueId: 0, // SourceRefValueId по файлам, загруженным в temporaryFiles
  disableCreateZip: false, // признак, что в последней выборке есть "формирующийся" файл
  carmenStatuses: [],
  carmenStatusesOrderId: null, // orderId по  статусам, которые должны быть в carmenStatuses
  responsibleUsers: [],
  executors: [],
  editors: [],
  tz: {
    timeZone: null, // таймзона, которая должна отображаться для `callTimeClientTimeZone`. берется с сервера, при изменении адреса
    timeZoneOffset: 0,
  },
  damagedItems: [], // повреждения по заявке
  damagedItemsOrderId: null, // orderId по  повреждениям, которые находятся в damagedItems
  loadingDamagedItems: false,
  blockData: null,
  orderReadOnly: true,

  history: [],
};

const ordersReducer = (state = initialState, action) => {
  switch (action.type) {
    case constants.RESET_ERROR:
    case constants.FETCH_ORDER_FIELDS:
    case constants.FETCH_ORDER_FIELDS_FAIL:
    case constants.FETCH_ORDER_FIELDS_SUCCESS:
    case constants.UPDATE_ORDER_FIELDS_STORE_SUCCESS:
    case constants.FETCH_ORDERS:
    case constants.FETCH_ORDERS_FAIL:
    case constants.FETCH_ORDERS_SUCCESS:
    case constants.FETCH_ORDER:
    case constants.FETCH_ORDER_SUCCESS:
    case constants.CREATE_ORDER:
    case constants.CREATE_ORDER_FAIL:
    case constants.CREATE_ORDER_SUCCESS:
    case constants.UPDATE_ORDER:
    case constants.UPDATE_ORDER_FAIL:
    case constants.UPDATE_ORDER_SUCCESS:
    case constants.DELETE_ORDER:
    case constants.DELETE_ORDER_FAIL:
    case constants.DELETE_ORDER_SUCCESS:
    case constants.FETCH_ORDER_PHOTOS:
    case constants.FETCH_ORDER_PHOTOS_FAIL:
    case constants.FETCH_ORDER_PHOTOS_SUCCESS:
    case constants.FETCH_ORDER_CLIENT_PHOTOS:
    case constants.FETCH_ORDER_CLIENT_PHOTOS_FAIL:
    case constants.FETCH_ORDER_CLIENT_PHOTOS_SUCCESS:
    case constants.CLEAR_ORDER_PHOTOS:
    case constants.CLEAR_ORDER_CLIENT_PHOTOS:
    case constants.FETCH_ORDER_INSTRUCTION:
    case constants.FETCH_ORDER_INSTRUCTION_FAIL:
    case constants.FETCH_ORDER_INSTRUCTION_SUCCESS:
    case constants.CLEAR_ORDER_INSTRUCTION:
    case constants.CREATE_ORDER_PHOTO:
    case constants.CREATE_ORDER_PHOTO_FAIL:
    case constants.CREATE_ORDER_PHOTO_SUCCESS:
    case constants.UPDATE_ORDER_PHOTO:
    case constants.UPDATE_ORDER_PHOTO_FAIL:
    case constants.UPDATE_ORDER_PHOTO_SUCCESS:
    case constants.DELETE_ORDER_PHOTO:
    case constants.DELETE_ORDER_PHOTO_FAIL:
    case constants.DELETE_ORDER_PHOTO_SUCCESS:
    case constants.RESTORE_ORDER_PHOTO:
    case constants.RESTORE_ORDER_PHOTO_FAIL:
    case constants.RESTORE_ORDER_PHOTO_SUCCESS:
    case constants.CREATE_ORDER_VIDEO:
    case constants.CREATE_ORDER_VIDEO_FAIL:
    case constants.CREATE_ORDER_VIDEO_SUCCESS:
    case constants.FETCH_ORDER_COMMENTS:
    case constants.FETCH_ORDER_COMMENTS_FAIL:
    case constants.FETCH_ORDER_COMMENTS_SUCCESS:
    case constants.CREATE_ORDER_COMMENT:
    case constants.CREATE_ORDER_COMMENT_SUCCESS:
    case constants.CREATE_ORDER_COMMENT_FAIL:
    case constants.DELETE_ORDER_COMMENT:
    case constants.DELETE_ORDER_COMMENT_SUCCESS:
    case constants.DELETE_ORDER_COMMENT_FAIL:
    case constants.FETCH_ORDER_TEMPORARY_FILES:
    case constants.FETCH_ORDER_TEMPORARY_FILES_SUCCESS:
    case constants.CLEAR_ORDER_TEMPORARY_FILES:
    case constants.CREATE_ORDER_TEMPORARY_FILES:
    case constants.CREATE_ORDER_TEMPORARY_FILES_FAIL:
    case constants.CREATE_ORDER_TEMPORARY_FILES_SUCCESS:
    case constants.FETCH_CARMEN_STATUSES:
    case constants.FETCH_CARMEN_STATUSES_SUCCESS:
    case constants.FETCH_ORDER_RESPONSIBLES_SUCCESS:
    case constants.FETCH_ORDER_RESPONSIBLES_FAIL:
    case constants.CREATE_ORDER_RESPONSIBLES_SUCCESS:
    case constants.CREATE_ORDER_RESPONSIBLES_FAIL:
    case constants.DELETE_ORDER_RESPONSIBLES_SUCCESS:
    case constants.DELETE_ORDER_RESPONSIBLES_FAIL:
    case constants.FETCH_TIMEZONE_SUCCESS:
    case constants.FETCH_TIMEZONE_FAIL:
    case constants.FETCH_ORDER_EXECUTORS_SUCCESS:
    case constants.FETCH_ORDER_EXECUTORS_FAIL:
    case constants.FETCH_ORDER_EDITORS_SUCCESS:
    case constants.FETCH_ORDER_EDITORS_FAIL:
    case constants.FETCH_DAMAGED_ITEMS:
    case constants.FETCH_DAMAGED_ITEMS_SUCCESS:
    case constants.CREATE_DAMAGED_ITEMS_FAIL:
    case constants.CREATE_DAMAGED_ITEMS_SUCCESS:
    case constants.DELETE_DAMAGED_ITEMS_FAIL:
    case constants.DELETE_DAMAGED_ITEMS_SUCCESS:
    case constants.UPDATE_DAMAGED_ITEMS_REDUX:
    case constants.BLOCK_ORDER_SUCCESS:
    case constants.BLOCK_ORDER_FAIL:
    case constants.UNBLOCK_ORDER_SUCCESS:
    case constants.UNBLOCK_ORDER_FAIL:
    case constants.RESET_BLOCK_DATA:
    case constants.CHANGE_ORDER_SERVICE_SUCCESS:
    case constants.CHANGE_ORDER_SERVICE_FAIL:
    case constants.FETCH_ORDER_HISTORY_SUCCESS:
    case constants.FETCH_ORDER_HISTORY_FAIL:
      return { ...state, ...action.payload };
    case constants.FETCH_ORDER_TEMPORARY_FILES_FAIL:
      return { ...state, ...action.payload, loadingTemporaryFiles: false, temporaryFilesOrderId: '' };
    case constants.FETCH_CARMEN_STATUSES_FAIL:
      return { ...state, ...action.payload, carmenStatusesOrderId: null };
    case constants.FETCH_ORDER_FAIL:
      return { ...state, ...action.payload, commentsOrderId: null };
    case constants.FETCH_DAMAGED_ITEMS_FAIL:
      return { ...state, ...action.payload, damagedItemsOrderId: null, loadingDamagedItems: false };
    default:
      return state;
  }
};

export default ordersReducer;
